module.exports = __webpack_public_path__ + "img/Icon-hisotry.ab23e291.svg";